<template>
  <div>
    <h1>Depositing to WSB</h1>
    
    <BackButton 
      text="Back to Deposit Menu"
      @click="backmenu"
    />
    
    <p>
      You can deposit money on your wallet. It's Easy!<br>
      <img src="/icons/airtel.png" alt="Airtel Money Logo" style="height: 20px; vertical-align: middle; margin-right: 5px;">
      Airtel Money Deposit.<br>
      Hello user: <a>{{ username }}</a>
    </p>

    <!-- Mostrar el contenedor solo si no se ha enviado el depósito -->
    <DepositForm
      v-if="showDepositForm"
      :username="username"
      :amounts="amounts"
      currency="MWK"
      :api-url="apiUrl"
      @deposit-submitted="handleDepositSubmitted"
      @deposit-success="handleDepositSuccess"
      @deposit-error="handleDepositError"
    />

    <!-- Mostrar el mensaje de éxito o error en la pantalla -->
    <ResponseMessage
      :message="responseMessage"
      :type="responseType"
    />

    <div class="finaltext">
      <p v-if="responseMessage">
        Your deposit should be on your account in a few seconds.
        If your deposit doesn't appear in your WSB balance in 5 seconds,<br>
        please <a href="javascript:void(0)" @click="redirectContact">CLICK HERE</a> to contact us to let us know.
      </p>
      <p v-else-if="!responseMessage">
        After completing the above steps, your deposit will appear on your wsbetting.co.mw account.
        Please allow a few seconds for this to happen.<br>
        <a>Note</a>: Make sure any pop-up blocker is disabled.
      </p>
    </div>
  </div>
</template>

<script>
import common from '@/scripts/common.js';
import BackButton from '@/components/BackButton.vue';
import DepositForm from '@/components/DepositFormAirtel.vue';
import ResponseMessage from '@/components/ResponseMessage.vue';

export default {
  components: {
    BackButton,
    DepositForm,
    ResponseMessage,
  },
  data() {
    return {
      inmaintenance: false,
      username: this.$route.query.username || "Unknown User",
      responseMessage: "",
      responseType: "",
      showDepositForm: true,
      amounts: [50, 100, 200, 300, 500, 700, 1000, 1500, 2000, 3000, 5000, 10000, 20000, 50000, 100000, 150000, 200000, 250000, 300000, 500000],
      apiUrl: process.env.VUE_APP_API_URL_AIRTEL
    };
  },
  methods: {
    backmenu() {
      this.$router.push({ 
        name: 'DepositWebsiteMalawi', 
        query: { username: this.$route.query.username } 
      });
    },
    redirectContact() {
      window.parent.postMessage({ action: 'btncontact' }, '*');
    },
    handleDepositSubmitted() {
      // Puedes agregar lógica adicional aquí si es necesario
    },
    handleDepositSuccess(result) {
      this.responseMessage = result;
      this.responseType = "success";
      this.showDepositForm = false;
    },
    handleDepositError(message) {
      this.responseMessage = message;
      this.responseType = "error";
      this.showDepositForm = false;
    },
    sendHeight() {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ iframeHeight: height }, "*");
    }
  },

  async mounted() {
    var maintenance = await common.checkMaintenanceMW("airtel");
    
    if (maintenance) {
      this.$router.push({ 
        name: 'DepositMaintenanceMalawi', 
        query: { username: this.$route.query.username } 
      });
    }

    // Enviar altura inicial al cargarse el componente
    this.sendHeight();

    // También puedes agregar un listener para resize si lo deseas
    window.addEventListener("resize", this.sendHeight);
  },

  updated() {
    // Enviar altura después de que el DOM se actualice (por si hay cambios dinámicos)
    this.$nextTick(() => {
      this.sendHeight();
    });
  },

  beforeUnmount() {
    // Limpiar el listener si lo agregaste
    window.removeEventListener("resize", this.sendHeight);
  }
};
</script>

<style scoped>
body {
  background-color: #f0f0f0;
  font-family: Arial, sans-serif;
}

h1 {
  color: #000;
  text-align: center;
  font-weight: 800;
  padding: 15px;
}

p {
  color: #555;
  text-align: center;
}

p strong {
  color: #000000;
}

.finaltext {
  padding-left: 10px;
  padding-right: 10px;
  display: block;
}
</style>
